export default "__VITE_ASSET__B_k$ScjL__"